export default __webpack_public_path__ + "static/media/eatingtimes_3.451ee72f.jpg";